module.exports = __webpack_public_path__ + "static/media/3 10 Tulleord Blastell er feil-norming.3b882ada.mp3";